import {
  Container,
  ContainerGutter,
  styled,
  Text,
  TokenTextAppearance,
  TokenTextColor,
  TextTag,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { CPOLogo } from '../../../svg/CPOLogo';
import { getLang, getTranslations } from '../../../translations';
import { VehicleData } from '../../../types';
import { VehicleCategory } from '../../../types/enums/vehicles';
import { useReachesBreakpoint } from '../../../utils/use-reaches-breakpoint';

export enum VehicleStatus {
  IN_TRANSIT = 'in transit',
  IN_PRODUCTION = 'in production',
  IN_STOCK = 'in stock',
}

export const getVehicleStatus = (vehicle: VehicleData) => {
  if (vehicle.in_production) {
    return VehicleStatus.IN_PRODUCTION;
  } else if (vehicle.in_transit) {
    return VehicleStatus.IN_TRANSIT;
  } else {
    return VehicleStatus.IN_STOCK;
  }
};
interface VehicleInventoryTypeInterface {
  apperance?: TokenTextAppearance;
  category: VehicleData['category'];
  demo: boolean;
  sold?: boolean;
  vehicleStatus: VehicleStatus;
}

const VehicleInventoryTypeWrapper = styled.div`
  color: #001e50;
  display: flex;
  column-gap: 8px;
  align-content: center;
`;

const StatusText = styled(Text)`
  ::before {
    content: ' - ';
  }
`;

const VehicleInventoryType = ({
  category,
  demo,
  vehicleStatus,
  apperance = TokenTextAppearance.headline200,
  sold = false,
}: VehicleInventoryTypeInterface) => {
  const reachesBreakpoint = useReachesBreakpoint();
  const lang = getLang();
  const trans = getTranslations();

  const getStatusLabel = (status: VehicleStatus) => {
    switch (status) {
      case VehicleStatus.IN_PRODUCTION:
        return trans.labels.in_production;
      case VehicleStatus.IN_TRANSIT:
        return trans.labels.in_transit;
      default:
        return trans.labels.in_stock;
    }
  };

  const statusLabel = getStatusLabel(vehicleStatus);

  return (
    <Container
      wrap="never"
      verticalAlign="center"
      gutter={ContainerGutter.static100}
    >
      <VehicleInventoryTypeWrapper>
        {!sold ? (
          category == VehicleCategory.CERTIFIED ? (
            <CPOLogo
              hideLogo
              lang={lang}
              appearance={apperance}
              lineBreak={reachesBreakpoint ? false : true}
            />
          ) : (
            <Text
              color={TokenTextColor.inherit}
              appearance={apperance}
              bold
              staticSize
            >
              {demo && category === VehicleCategory.NEW
                ? trans.results.vehicleType.demo
                : trans.results.vehicleType[category]}

              {demo && category !== VehicleCategory.NEW ? (
                <Text tag={TextTag.span} appearance={apperance}>
                  {' ' + trans.labels.demo_pin}
                </Text>
              ) : null}

              <StatusText
                tag={TextTag.span}
                bold={false}
                appearance={apperance}
              >
                {statusLabel}
              </StatusText>
            </Text>
          )
        ) : (
          <Text
            color={TokenTextColor.inherit}
            appearance={apperance}
            bold
            staticSize
          >{trans.labels.newSearch.sold}</Text>
        )}
      </VehicleInventoryTypeWrapper>
    </Container>
  );
};

export default VehicleInventoryType;
